import React, { useState } from 'react';
import useReveal from '../hooks/useReveal';
import './Gallery.css';
import { trackEvent } from '../analytics';

const PHOTOS = [
  {
    src: '/assets/images/gallery-bootcamp-award.jpg',
    alt: 'Inivayal team receiving recognition at the GDC I-NDUCT Innovation & Entrepreneurship Bootcamp',
    caption: 'GDC I-NDUCT Bootcamp',
    body: 'Recognised at the 3-day Innovation & Entrepreneurship Bootcamp.',
  },
  {
    src: '/assets/images/gallery-incubation.jpg',
    alt: 'Inivayal founders being incubated at the Crescent Innovation and Incubation Council',
    caption: 'Incubated at CIIC',
    body: 'Officially incubated at the Crescent Innovation and Incubation Council.',
  },
  {
    src: '/assets/images/gallery-team-meeting.jpg',
    alt: 'Inivayal team in a strategy meeting',
    caption: 'Team strategy session',
    body: 'The wider Inivayal team planning the product roadmap together.',
  },
];

export default function Gallery() {
  const ref = useReveal();
  const gridRef = useReveal();
  const [active, setActive] = useState(null);

  const open = (i) => {
    setActive(i);
    trackEvent('gallery_open', { photo: PHOTOS[i].caption });
  };

  return (
    <section className="section gallery" id="gallery">
      <div className="container">
        <div className="reveal" ref={ref}>
          <p className="eyebrow">Gallery</p>
          <h2 className="section-heading">Milestones on the ground.</h2>
        </div>

        <div className="gallery__grid reveal-stagger" ref={gridRef}>
          {PHOTOS.map((p, i) => (
            <button className="gallery__item" key={p.src} onClick={() => open(i)}>
              <img src={p.src} alt={p.alt} loading="lazy" />
              <div className="gallery__overlay">
                <strong>{p.caption}</strong>
                <span>View</span>
              </div>
            </button>
          ))}
        </div>
      </div>

      {active !== null && (
        <div className="gallery__lightbox" onClick={() => setActive(null)}>
          <button className="gallery__close" aria-label="Close" onClick={() => setActive(null)}>
            &times;
          </button>
          <figure onClick={(e) => e.stopPropagation()}>
            <img src={PHOTOS[active].src} alt={PHOTOS[active].alt} />
            <figcaption>
              <strong>{PHOTOS[active].caption}</strong>
              <span>{PHOTOS[active].body}</span>
            </figcaption>
          </figure>
        </div>
      )}
    </section>
  );
}
